/**
 * BLOC INTRO
 * Révélation mot par mot au scroll : tous les mots démarrent à 20% d'opacité
 * et atteignent 100% quand le texte arrive à la moitié de l'écran.
 */
jQuery(document).ready(function ($) {

    const OPACITE_DEPART = .2   // opacité des mots avant révélation
    const MOT_DUREE = .25       // durée de révélation d'un mot, relative au stagger
    const MOT_STAGGER = .06     // décalage d'un mot au suivant
    const LISSAGE = .5          // secondes de rattrapage du scroll

    // animations réduites : le texte reste à pleine opacité, aucun découpage
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
        return

    $(".bloc_intro .texte").each(function () {
        const texte = this

        /**
         * SplitText 3.13 pose lui-même aria-label sur le conteneur et aria-hidden
         * sur les mots : le texte reste lisible par les lecteurs d'écran.
         * tag: span plutôt que le div par défaut, pour rester valide dans un <p>.
         */
        const decoupe = new SplitText(texte, { type: "words", wordsClass: "mot", tag: "span" })

        if (!decoupe.words.length)
            return

        /**
         * SplitText impose display: inline-block à ses fragments, ce qui fait
         * occuper à chacun la hauteur de sa propre line-height dans la ligne au
         * lieu de s'aligner sur les métriques de la police : les interlignes se
         * retrouvent gonflés. On n'anime que l'opacité, donc l'inline-block est
         * inutile et on rend au texte ses métriques d'origine.
         */
        gsap.set(decoupe.words, { display: "inline" })

        /**
         * Le stagger étale les mots sur toute la plage de scroll : le dernier
         * termine sa révélation exactement à la fin, quand le haut du texte
         * atteint le milieu de l'écran.
         */
        gsap.fromTo(decoupe.words,
            { opacity: OPACITE_DEPART },
            {
                opacity: 1,
                ease: "none",
                duration: MOT_DUREE,
                stagger: { each: MOT_STAGGER, from: "start" },
                scrollTrigger: {
                    trigger: texte,
                    start: "top bottom",
                    end: "top center",
                    scrub: LISSAGE
                }
            })
    })

})
